// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-slides {
    padding-top: 20px !important;
    padding-bottom: 10px !important;
    padding-left: 30px !important;
    padding-right: 20px !important;
    background-color: white;
}

.all-slides-mobile {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
    background-color: white;
}

.pagination-mp {
    float: right;
    margin-top: 5px !important;
    margin-bottom: 5px !important;
}

.row-actions {
    margin: 5px;
}

.analysis-data-table td {
    padding: 1px 1px !important;
}

.slide-table-rows {
    cursor: pointer;
}

.slide-table-rows > td {
    padding: 4px 8px !important;
}

.slidelist-tag {
    font-size: 14px;
    cursor : pointer !important;
    margin: 3px 3px;
}

.search-result-tag {
    margin-right:10px;
    margin-bottom: 5px;
}

.search-input {
    width: 100%;
    margin-bottom:20px !important;
    font-size: 14px;
    letter-spacing: normal;
}

.search-tag {
    width: 200px;
    margin-bottom:20px !important;
}

.fixed-controls-dashboard {
    z-index:1;
    background-color: white;

}

/*.ant-checkbox {*/
/*    padding:25px !important;*/
/*}*/

.tags-section {
    border-top: 1px solid #1890ff4d;
    border-bottom: 1px solid #1890ff4d;
    padding: 10px;
}

.tags-button {
    margin: 5px;
}


.lighter-danger-button {
    border-color: #ff4d4fcc !important;
}

.text-style {
    font-size: 12px;
}

.custom-table-padding > td {
    padding: 5px 5px !important;
}

.slide-icons {
    font-size: 18px; 
    padding: 5px; 
    display: inline-table;
}

.underline-hover:hover {
    text-decoration: underline;
}

.custom-font-family .ant-progress-inner .ant-progress-text {
    font-family: 'ubuntu';
}


.row-flex {
    display: flex;
    flex-direction: row;
}

.column-flex {
    display: flex;
    flex-direction: column;
}

.add-tag-row-selection-input {
    margin-bottom: 0 !important;
}

.preserve-white-space{
    white-space: pre;
}

.custom-dropdown-max-height .ant-select-dropdown-menu {
    max-height: none;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/dashboard.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,uBAAuB;;AAE3B;;AAEA,kBAAkB;AAClB,+BAA+B;AAC/B,IAAI;;AAEJ;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".all-slides {\n    padding-top: 20px !important;\n    padding-bottom: 10px !important;\n    padding-left: 30px !important;\n    padding-right: 20px !important;\n    background-color: white;\n}\n\n.all-slides-mobile {\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n    background-color: white;\n}\n\n.pagination-mp {\n    float: right;\n    margin-top: 5px !important;\n    margin-bottom: 5px !important;\n}\n\n.row-actions {\n    margin: 5px;\n}\n\n.analysis-data-table td {\n    padding: 1px 1px !important;\n}\n\n.slide-table-rows {\n    cursor: pointer;\n}\n\n.slide-table-rows > td {\n    padding: 4px 8px !important;\n}\n\n.slidelist-tag {\n    font-size: 14px;\n    cursor : pointer !important;\n    margin: 3px 3px;\n}\n\n.search-result-tag {\n    margin-right:10px;\n    margin-bottom: 5px;\n}\n\n.search-input {\n    width: 100%;\n    margin-bottom:20px !important;\n    font-size: 14px;\n    letter-spacing: normal;\n}\n\n.search-tag {\n    width: 200px;\n    margin-bottom:20px !important;\n}\n\n.fixed-controls-dashboard {\n    z-index:1;\n    background-color: white;\n\n}\n\n/*.ant-checkbox {*/\n/*    padding:25px !important;*/\n/*}*/\n\n.tags-section {\n    border-top: 1px solid #1890ff4d;\n    border-bottom: 1px solid #1890ff4d;\n    padding: 10px;\n}\n\n.tags-button {\n    margin: 5px;\n}\n\n\n.lighter-danger-button {\n    border-color: #ff4d4fcc !important;\n}\n\n.text-style {\n    font-size: 12px;\n}\n\n.custom-table-padding > td {\n    padding: 5px 5px !important;\n}\n\n.slide-icons {\n    font-size: 18px; \n    padding: 5px; \n    display: inline-table;\n}\n\n.underline-hover:hover {\n    text-decoration: underline;\n}\n\n.custom-font-family .ant-progress-inner .ant-progress-text {\n    font-family: 'ubuntu';\n}\n\n\n.row-flex {\n    display: flex;\n    flex-direction: row;\n}\n\n.column-flex {\n    display: flex;\n    flex-direction: column;\n}\n\n.add-tag-row-selection-input {\n    margin-bottom: 0 !important;\n}\n\n.preserve-white-space{\n    white-space: pre;\n}\n\n.custom-dropdown-max-height .ant-select-dropdown-menu {\n    max-height: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
